import styled, { css } from "styled-components";

interface IProjectDetailsModalWrapper {
  show: number;
}

export const ProjectDetailsModalWrapper = styled.div<
  IProjectDetailsModalWrapper
>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(18, 18, 18, 0.6);
  z-index: 100;
  opacity: ${(props) => (props.show ? "1" : "0")};
  visibility: ${(props) => (props.show ? "visible" : "hidden")};

  ${(props) =>
    props.show &&
    css`
      & > div {
        right: 1rem;
      }
    `}
`;

export const ProjectDetailsModalContainer = styled.div`
  position: absolute;
  top: 1rem;
  right: -100%;
  width: 50rem;
  height: calc(100% - 2rem);
  background: #212225;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-radius: 4px;
  transition: right 0.2s ease;
`;

export const ProjectDetailsModalHeader = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > h1 {
    color: rgba(0, 0, 0, 0.6);
    text-shadow: 2px 2px 3px rgba(255, 255, 255, 0.06);
    font-size: 1.8rem;
    text-transform: uppercase;
  }

  & > svg {
    color: rgba(0, 0, 0, 0.6);
    filter: drop-shadow(2px 2px 3px rgba(255, 255, 255, 0.06));
    font-size: 1.6rem;
    cursor: pointer;
  }
`;

interface IProjectDetailsModalBody {
  copied?: number;
}

export const ProjectDetailsModalBody = styled.div<IProjectDetailsModalBody>`
  width: 100%;
  height: auto;

  & > h3 {
    color: rgba(255, 255, 255, 0.5);
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 1rem;
    text-decoration: underline;
  }

  & > img {
    background: #181818;
    padding: 1rem;
    border-radius: 2px;
    margin-bottom: 3rem;
    opacity: 0.5;
  }

  & > p {
    background: #181818;
    padding: 1rem;
    border-radius: 2px;
    margin-bottom: 1rem;
  }

  & > span {
    background: #181818;
    padding: 1rem;
    border-radius: 2px;
    margin-bottom: 1rem;
    color: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: flex-start;
    align-items: center;

    & > svg {
      margin-right: 1rem;
      cursor: pointer;

      &:hover {
        opacity: 0.5;
      }
    }

    & span {
      margin-left: auto;
      color: rgba(255, 255, 255, 0.5);
      text-shadow: 2px 2px 3px rgba(255, 255, 255, 0.06);
      opacity: ${(props) => (props.copied === 1 ? "1" : "0")};
      visibility: ${(props) => (props.copied === 1 ? "visible" : "hidden")};
      transition: all 0.2s ease;
    }
  }

  & > div {
    background: #181818;
    border-radius: 2px;
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    padding: 0.5rem;

    & > span {
      background: rgba(0, 0, 0, 0.2);
      padding: 0.5rem 0.8rem;
      border-radius: 2px;
      margin: 0.5rem;
      text-transform: uppercase;
      font-size: 1.2rem;
      font-weight: 700;
      filter: drop-shadow(2px 2px 3px rgba(255, 255, 255, 0.06));
      color: rgba(255, 255, 255, 0.5);
    }
  }
`;

export const ProjectDetailsModalFooter = styled.div`
  margin-top: auto;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;

  & > svg {
    color: rgba(0, 0, 0, 0.6);
    filter: drop-shadow(2px 2px 3px rgba(255, 255, 255, 0.06));
    font-size: 1.6rem;
    cursor: pointer;
  }
`;
